import { ITimeOffRequest, ITimeOffRequestData } from '../timeoff-request.types';
import { TimeOffRequest, TimeOffRequestComment } from '../timeoff-request';
import {
  IMentionAttachmentComment,
  IMentionAttachmentCommentData
} from '@/models/comment';

export const mockTimeOffRequestCommentsData = (): IMentionAttachmentCommentData[] => [
  {
    id: 1,
    owner: 'John Doe',
    text: 'Text',
    created_at: '2022-09-19T20:09:52.928777Z',
    updated_at: '2022-09-19T20:09:52.928825Z'
  },
  {
    id: 1,
    owner: 'Bull Joe',
    text: 'Text',
    created_at: '2022-09-19T20:10:52.928777Z',
    updated_at: '2022-09-19T20:11:52.928825Z'
  }
];

export const mockTimeOffRequestsData = (): ITimeOffRequestData[] => [
  {
    id: 1,
    state: 0,
    timeoff_unit: { value: 0, display_unit: 'Day(s)' },
    type: {
      id: 1,
      name: 'Sick Day'
    },
    employee: {
      id: 1,
      type: 0,
      first_name: 'Andy',
      last_name: 'Watson edit',
      employee_number: '4053'
    },
    type_requested_subtype: 0,
    entitlement_year: 2022,
    owner: 'Lamar Falconer',
    start: '2022-09-19',
    end: '2022-09-21',
    notes: 'notes',
    created_at: '2022-09-19T20:09:52.928777Z',
    updated_at: '2022-09-19T20:09:52.928825Z'
  },
  {
    id: 1,
    state: 1,
    timeoff_unit: { value: 0, display_unit: 'Day(s)' },
    type: {
      id: 1,
      name: 'Vacation'
    },
    employee: {
      id: 1,
      type: 0,
      first_name: 'Andy',
      last_name: 'Watson edit',
      employee_number: '4053'
    },
    type_requested_subtype: 0,
    entitlement_year: 2022,
    owner: 'Lamar Falconer',
    start: '2022-09-19',
    end: '2022-09-21',
    notes: 'notes',
    created_at: '2022-09-19T20:09:52.928777Z',
    updated_at: '2022-09-19T20:09:52.928825Z'
  }
];

export const mockTimeOffRequests = (
  data: ITimeOffRequestData[] = mockTimeOffRequestsData()
): ITimeOffRequest[] => data.map(item => new TimeOffRequest(item));

export const mockTimeOffRequestComments = (
  data: IMentionAttachmentCommentData[] = mockTimeOffRequestCommentsData()
): IMentionAttachmentComment[] =>
  data.map(item => new TimeOffRequestComment(item));
